import { variables } from "../variables";

export default {
    state: {
        currentClub: null,
        admins:[],
        adminSelected: ""
    },
    getters: {
        getAdminSelected(state){
            return state.adminSelected;
        },
        getAdmins(state){
            return state.admins
        }
    },
    mutations: {
        setAdminSelected(state, value){
            state.adminSelected = value
        },
        setListOfAdmins(state, value){
            state.admins = value
        }    
    },
    actions: {
        async getListOfClubs(context){
            let response = await context.rootGetters.api.get(variables.serverUrl+'/api/v1/clubs?pageNumber=0&pageSize=15');
            return response
        },
        async getListOfAdmins(context){
            let response = await context.rootGetters.api.get(variables.serverUrl+'/api/v1/clubs/unassigned-administrators');
           return response;

        },
        async updateClub(context, body){
            let response = await context.rootGetters.api.put(variables.serverUrl+'/api/v1/clubs/'+body.uuid, body.data)
            return response
        },
        async obtainLocations(context, cp){
            let response = await context.rootGetters.api.get(variables.serverUrl+'/api/v1/locations/'+cp)
            return response;
        
        },
        async deleteClub(context, clubCode){
            let response = await context.rootGetters.api.delete(variables.serverUrl+'/api/v1/clubs/'+clubCode)
            return response;
        },
        async postClub(context, body){
            let response = await context.rootGetters.api.post(variables.serverUrl+'/api/v1/clubs/', body)
            return response
        },

    }
}